export class CarMotor {

    id: number;
    name: string;
}